// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-default[data-v-665894d4]{color:var(--color-text-3);padding:var(--spacing-md-3) 0;text-align:center}.error-default__title[data-v-665894d4]{font-size:var(--font-size-xl-1);font-weight:var(--font-weight-bold);line-height:var(--font-size-xl-1);padding:var(--spacing-md-3) 0 0}.error-default__text[data-v-665894d4]{font-size:var(--font-size-md-2);font-weight:var(--font-weight-bold);padding:var(--spacing-md-3) var(--spacing-md-3)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
